import { fg } from '@atlassian/jira-feature-gating';

const JiraForYouLandAllNewUsersRelayProvider = {
	get(): boolean {
		return fg('jfy-integrate-new-user-check');
	},
};

export default JiraForYouLandAllNewUsersRelayProvider;
